var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{attrs:{"buttonClass":"button-alert","tooltipTitle":"Remove all data from your cache"},on:{"click":_vm.flushCache}},[_c('BaseIcon',{attrs:{"icon":"trash"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }